import { EmptyDataPlaceholder } from "@/components/src/empty-with-label/empty-data-placeholder.component";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
} from "../../../../components/ui/dialog";
import { PauseCircle } from "lucide-react";
import {
	PaymentReminderHistoryRow,
	ReminderInvoiceRef,
} from "../payment-reminder.types";
import { formatReminderDate } from "../utils/reminder-placeholders";
import { ReminderHistoryTable } from "./reminder-history-table.component";

interface InvoiceReminderHistoryDialogProps {
	invoice: ReminderInvoiceRef | null;
	rows: PaymentReminderHistoryRow[];
	onClose: () => void;
	onChanged: () => void;
}

export const InvoiceReminderHistoryDialog: React.FC<
	InvoiceReminderHistoryDialogProps
> = ({ invoice, rows, onClose, onChanged }) => {
	return (
		<Dialog
			open={invoice !== null}
			onOpenChange={(isOpen) => !isOpen && onClose()}
		>
			<DialogContent
				className="sm:max-w-5xl"
				data-testid="invoice-reminder-history-dialog"
				aria-label="Mahnverlauf"
			>
				<DialogHeader>
					<DialogTitle>Mahnverlauf</DialogTitle>
					<DialogDescription>
						Rechnung {invoice?.docNumber}
					</DialogDescription>
				</DialogHeader>
				{invoice?.paused && (
					<div
						role="note"
						data-testid="invoice-reminder-pause-info"
						className="flex items-start gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900"
					>
						<PauseCircle className="mt-0.5 h-4 w-4 shrink-0" />
						<span>
							Mahnstopp{" "}
							{invoice.pausedUntil
								? `bis ${formatReminderDate(invoice.pausedUntil)}`
								: "unbefristet"}
							{invoice.stopReason && ` · ${invoice.stopReason}`}
						</span>
					</div>
				)}
				{rows.length > 0 ? (
					<ReminderHistoryTable
						rows={rows}
						onChanged={onChanged}
						showInvoice={false}
					/>
				) : (
					!invoice?.paused && (
						<EmptyDataPlaceholder label="Für diese Rechnung wurden noch keine Mahnungen erstellt" />
					)
				)}
			</DialogContent>
		</Dialog>
	);
};

